import React from "react";
import styled from "styled-components";
import { SubtitleSection } from "@domain/lms/article/article";

interface SubtitleSectionViewProps extends React.HTMLAttributes<HTMLDivElement> {
	section: SubtitleSection;
}
export const SubtitleSectionView: React.FC<SubtitleSectionViewProps> = ({ section, ...htmlProps }) => {
	return (
		<Container {...htmlProps} id={section.id}>
			{section.title}
		</Container>
	);
};

const Container = styled.div`
	${({ theme }) => theme.textStyles.desktopSubtitle};
	padding-left: 40px;
	@media (max-width: 900px) {
		padding-left: 20px;
	}
	font-family: Sora;
	font-style: normal;
	font-weight: 600;
	font-size: 26px;
	line-height: 35px;
`;
